// combatpro/views/NotesView.js
//
// Stage 33: view-notes shell. Stage 72 (Notes View Foundation) migrates the legacy
// per-monster Notes card (battletracker.html notes-block, 6222-6232) for the ACTIVE
// monster.
//
// The legacy built one notes-block-${i} per monster inside createMonsterPanel and
// reparented the active one into #vi-notes-mount via vi_mountNotes (10297), syncing the
// textarea value imperatively (6775). React renders the active monster's card directly
// from state.currentCombatantIndex (the established active-monster view pattern) - no
// reparenting, no getElementById.
//
// Faithful migration (master spec preserved verbatim):
//   - the static section header (📝 Notes & Special Abilities) and the static helper
//     paragraph (6223-6227).
//   - a single textarea bound to the active monster's notes, with the verbatim
//     placeholder. The legacy onchange called updateMonsterField(index, 'notes',
//     this.value) (6229); React binds value={monster.notes} and routes onChange through
//     the SAME existing handler.
//
// OWNERSHIP (determined from discovery): notes is a top-level MONSTER field
// (monsterEngine factory L74: notes ""), populated by the Stage 61 selection runtime
// (6761) and persisted by the existing monster-state mechanism. updateMonsterField does
// a generic top-level write ({...m,[field]:value}) and is already the exact seam the
// legacy textarea used and is already exposed on the context value, so notes is fully
// covered with NO new handler and NO CombatContext change. (Note: the Stage 40
// updateMonsterField comment lists notes among "inert" fields; that comment predates
// this Notes migration and does not reflect the current implementation, which already
// supports the field - no code change was required.) No local component state, no
// debounce, no persistence change. No DOM manipulation, no getElementById. No optional
// chaining. No em dash.

import React, { useContext } from 'react';
import { CombatContext } from '../contexts/CombatContext';

function NotesView() {
  const { state, updateMonsterField } = useContext(CombatContext);
  const index = state.currentCombatantIndex;
  const monster = state.monsters[index];

  if (!monster) {
    return (
      <div className="vi-view" id="view-notes">
        <div id="vi-notes-mount"></div>
      </div>
    );
  }

  const notes = (monster.notes != null) ? monster.notes : '';

  return (
    <div className="vi-view" id="view-notes">
      <div id="vi-notes-mount">
        <div id={'notes-block-' + index}>
          <div className="vi-section-header">
            <h3>📝 Notes & Special Abilities</h3>
          </div>
          <div className="vi-notes-body">
            <p className="vi-notes-helper">Use this section to record special abilities, passive traits, combat tactics, and behavioural notes for this creature. Include anything that affects how the monster acts during combat, such as triggers, conditions, or unique mechanics. You can also use this space for reminders, strategy notes, or custom rulings that should be referenced during play.</p>
            <textarea
              id={'notes-' + index}
              placeholder="Special abilities, tactics, behavior notes, or any other information about this creature..."
              className="vi-notes-textarea"
              value={notes}
              onChange={function(e) { updateMonsterField(index, 'notes', e.target.value); }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotesView;
